// extracted by mini-css-extract-plugin
module.exports = {"divider":"CharacterSheetHealthCircle_divider_21U-i","circle":"CharacterSheetHealthCircle_circle_1vBo7","red":"CharacterSheetHealthCircle_red_1iifP"};